import validate from 'jquery-validation';
import { layer } from './plugins/layer/index';

(function () {
	if ($('#loginForm').length) {
		let ajax_bol = true,
			formObj = $('#loginForm');
		formObj.validate({
			submitHandler: function (form) {
				if (ajax_bol == false) {
					return false;
				}
				ajax_bol = false;
				const actionUrl = $(form).attr("action");
				const postData = $(form).serialize();
				$.ajax({
					type: "POST",
					dataType: "json",
					url: actionUrl,
					data: postData,
					error: function () {
						layer.msg('We have encountered an error. Please try again later.')
						ajax_bol = true;
					},
					beforeSend: function () { },
					success: function (rs) {
						if (rs.success) {
							formObj[0].reset();
							location.href = rs.url;
						} else {
							layer.msg(rs.info)
						}
						ajax_bol = true;
					}
				});
			},
			rules: {
				email: {
					required: true
				},
				pwd: {
					required: true
				}
			},
			messages: {
				email: {
					required: "Account cannot be empty."
				},
				pwd: {
					required: "Please enter the password."
				}
			}
		});

	}

	
})();